import axios from 'axios';
import { authState } from '../recoil/auth/authState';
import { getCookie, setCookie } from '../cookie/Cookie';
import { reissue } from './Endpoint';
import { setRecoil } from 'recoil-nexus';

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function addSubscriber(callback) {
  subscribers.push(callback);
}

function onAccessTokenFetched(accessToken) {
  subscribers.forEach((callback) => callback(accessToken));
  subscribers = [];
}

// ✅ resetToken을 전역 함수로 변경 (useNetwork 없이 사용 가능)
const resetToken = async (interceptorError) => {
  console.log(interceptorError);
  try {
    const { response: errorResponse } = interceptorError;

    const retryOriginalRequest = new Promise((resolve, reject) => {
      addSubscriber(async (accessToken) => {
        try {
          errorResponse.config.headers['Authorization'] = `Bearer ${accessToken}`;
          resolve(req2(errorResponse.config));
        } catch (error) {
          reject(error);
        }
      });
    });

    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;

      const authCookie = getCookie('auth');
      const token = authCookie?.token;

      if (!token?.refreshToken) {
        throw new Error('Refresh Token이 없습니다.');
      }

      const { data } = await reissue({ accessToken: token.accessToken, refreshToken: token.refreshToken });

      if (data.responseStatus.code === 'C0001') {
        const newToken = data.data.token;

        setRecoil(authState, (prevState) => ({
          ...prevState,
          token: newToken,
        }));

        setCookie('auth', {
          ...getCookie('auth'),
          token: newToken,
        }, { path: '/', expires: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000) });

        isAlreadyFetchingAccessToken = false;
        onAccessTokenFetched(newToken.accessToken);
      } else {
        throw new Error('토큰 재발급 실패');
      }
    }

    return retryOriginalRequest;
  } catch (error) {
    isAlreadyFetchingAccessToken = false;
    subscribers = [];

    console.error('[Network] Token Reissue Error:', error);

    setRecoil(authState, {
      loginStatus: 'LOGOUT_ALL',
      teacher: {},
      token: {},
    });

    setCookie('auth', {
      loginStatus: 'LOGOUT_ALL',
      teacher: {},
      token: {},
    }, { path: '/', expires: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000) });

    alert('로그인이 만료되었습니다. 다시 로그인해주세요.');

    return Promise.reject(error);
  }
};

// ✅ 요청 인터셉터 (토큰 자동 추가)
const req = axios.create({
  baseURL: process.env.REACT_APP_HOST,
  headers: {
    'Content-Type': 'application/json',
  },
});

const req2 = axios.create({
  baseURL: process.env.REACT_APP_HOST,
  headers: {
    'Content-Type': 'application/json',
  },
});

req2.interceptors.request.use(
    (config) => {
      const authCookie = getCookie('auth');
      const token = authCookie?.token?.accessToken;

      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      } else {
        alert("로그인이 필요합니다.");
        window.location.href = `${process.env.REACT_APP_IS_OAUTH2_URL}?serviceId=${process.env.REACT_APP_IS_OAUTH2_SERVICE_ID}&secret=${process.env.REACT_APP_IS_OAUTH2_SECRET}&ld=loginDirect&mode=login&callback_uri=${process.env.REACT_APP_IS_OAUTH2_CALL_BACK_URL}`;
        return Promise.reject(new Error("No Token")); // 요청 중단
      }

      return config;
    },
    (error) => Promise.reject(error),
);

// ✅ 응답 인터셉터 (401 처리 및 resetToken 호출)
req2.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        const code = error.response?.data?.code;
        console.log(code);
        if (['ExpiredToken', 'LOGGED_OUT_ACCOUNT'].includes(code)) {
          console.log(error);
          return await resetToken(error); // ✅ useNetwork() 없이 resetToken 직접 호출
        }
      }

      return Promise.reject(error);
    }
);

export { req, req2 };
